import React from 'react';
import PropTypes from 'prop-types';

function AnswerOption(props) {
  return (
    <div className="col-md">
      <a className="answer-a">
        <div className="answer-option"
             value={props.value}
             onClick={props.onAnswerSelected}
             checked={props.answerType === props.answer}
             id={props.answerType}
             disabled={props.answer}
             data-pointvalue="0">
          <h6 className="answer-option__text">{props.answerContent}</h6>
        </div>
      </a>
    </div>
  );
}

AnswerOption.propTypes = {
  answerType: PropTypes.string.isRequired,
  answerContent: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onAnswerSelected: PropTypes.func.isRequired
};

export default AnswerOption;